import { useQuery } from '@tanstack/react-query';
import type { AccountApiSignupShow } from '@/types/serializers';

export default function useFetchSignupInfo(id: string) {
  return useQuery({
    queryKey: ['signup', id],
    queryFn: async (): Promise<AccountApiSignupShow> => {
      const response = await fetch(`/account/api/signup/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        window.location.href = '/agent/account/login';
      }
      const data = await response.json();
      return data;
    },
    enabled: !!id,
  });
}
